// extracted by mini-css-extract-plugin
export default {"container":"subtitle-module_container_l2Uelh","text":"subtitle-module_text_Dw9ZV9"};